// extracted by mini-css-extract-plugin
export default {"Modal-Header":"style_Modal-Header__LkVI-"};